export class Airport {
  code: string;
  name: string;
  city: string;
  country: string;
  timezoneName: string
}
